"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var decorators_1 = require("../util/decorators");
var factories_1 = require("../util/factories");
/* tslint:enable:interface-name */
exports.Component = decorators_1.makeDecorator('Component', function (c) {
    if (c === void 0) { c = {}; }
    return (__assign({}, c));
});
exports.createComponent = factories_1.makeMetadataFactory('Component', function (c) {
    if (c === void 0) { c = {}; }
    return (__assign({}, c));
});
